import { useCallback, useEffect, useState } from 'react';
import { getGradesEntryConfig } from '../api/requests/gradesEntry';
import { GradesEntryConfig } from '../types/GradesEntry';

export default function useValidatorNotes() {
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const [errorLoading, setErrorLoading] = useState<boolean>(false);
  const [config, setConfig] = useState<{
    max: number;
    min: number;
    decimalsLength: number;
    pass: number;
  }>({
    max: 0,
    min: 0,
    decimalsLength: 0,
    pass: 0,
  });

  const requestData = useCallback(async () => {
    let { data, error } = await getGradesEntryConfig();
    if (error) {
      setErrorLoading(true);
    } else if (data) {
      setErrorLoading(false);
      const max = data.find(
        (config) => config.key === 'grades-entry.maximum-grade',
      ) as GradesEntryConfig;
      const min = data.find(
        (config) => config.key === 'grades-entry.minimum-grade',
      ) as GradesEntryConfig;
      const decimalsLength = data.find(
        (config) => config.key === 'grades-entry.number-of-decimals-to-show',
      ) as GradesEntryConfig;
      const pass = data.find(
        (config) => config.key === 'grades-entry.passing-grade',
      ) as GradesEntryConfig;

      setConfig({
        max: max.value,
        min: min.value,
        decimalsLength: decimalsLength.value,
        pass: pass.value,
      });
    }
    setIsLoad(true);
  }, []);

  const formatterNumber = useCallback(
    (value: string) => {
      const { max, min, decimalsLength } = config;
      if (
        Number(value) >= min &&
        Number(value) <= max &&
        value.length <= decimalsLength + 2
      ) {
        return `${value}`;
      }
      return '';
    },
    [config],
  );

  const formatterNumberExternal = useCallback((value: string) => {
    if (Number(value) > 0) {
      return `${value}`;
    }
    return '';
  }, []);

  const formattertNote = useCallback(
    (value: string) => {
      if (/[0-9]|[0-9].[0-9]/.test(value)) {
        return formatterNumber(value);
      }
      return '';
    },
    [formatterNumber],
  );

  const formattertExternalNote = useCallback(
    (value: string) => {
      if (/[0-9]|[0-9].[0-9]/.test(value)) {
        return formatterNumberExternal(value);
      }
      return '';
    },
    [formatterNumberExternal],
  );

  useEffect(() => {
    requestData();
  }, [requestData]);
  return {
    config,
    isLoad,
    formattertExternalNote,
    formattertNote,
    errorLoading,
  };
}
